// Tickets menu and language switcher: each [data-open] wrapper toggles from its aria-expanded button
document.querySelectorAll('.site-header [data-open]').forEach((dropdown) => {
    const toggle = dropdown.querySelector('button[aria-expanded]');

    if (!toggle) {
        return;
    }

    const isOpen = () => dropdown.dataset.open === 'true';

    const setOpen = (open) => {
        dropdown.dataset.open = open;
        toggle.setAttribute('aria-expanded', open);
    };

    toggle.addEventListener('click', () => setOpen(!isOpen()));

    document.addEventListener('click', (event) => {
        if (isOpen() && !dropdown.contains(event.target)) {
            setOpen(false);
        }
    });

    dropdown.addEventListener('focusout', (event) => {
        if (!dropdown.contains(event.relatedTarget)) {
            setOpen(false);
        }
    });

    dropdown.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && isOpen()) {
            setOpen(false);
            toggle.focus();
        }
    });
});
